import React from 'react';
import styles from './RateSummaryNeedsAtention.module.scss';
import {RateSummaryNeedsAttentionItem} from 'typing/dto';
import {RateSummaryAlertCard} from '../rate-summary-alert-card/RateSummaryAlertCard';

interface RateSummaryNeedsAttentionProps {
    items: RateSummaryNeedsAttentionItem[];
}

export const RateSummaryNeedsAttention: React.FC<RateSummaryNeedsAttentionProps> = ({ items }) => {
    return (
        <div className={styles.container}>
            {items.map((item, index) => (
                <RateSummaryAlertCard
                    key={index}
                    type="warning"
                    item={{
                        title: item.title,
                        description: item.description,
                        tooltip: item.extraInfo,
                        tooltipTitle: "Needs Attention",
                        confidence: item.confidence
                    }}
                />
            ))}
        </div>
    );
}; 